module.exports = __webpack_public_path__ + "static/media/Quest-Sisters_and_Songs.ac71af69.png";